import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledTestimonialsQuote } from "./testimonials-quote.scss";
import DefaultProps from "./default-props";
class TestimonialsQuote extends PureComponent {
    render() {
        const { testimonial, removeQuote, quoteFontSize, quoteLineHeight } = this.props;
        return /*#__PURE__*/ _jsxs(StyledTestimonialsQuote, {
            className: "testimonials-quote",
            children: [
                !removeQuote && /*#__PURE__*/ _jsx("div", {
                    className: "quote-background"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "testimonials-text",
                    style: {
                        fontSize: quoteFontSize,
                        lineHeight: quoteLineHeight
                    },
                    children: testimonial
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export { TestimonialsQuote as default };
TestimonialsQuote.defaultProps = DefaultProps;
